// extracted by mini-css-extract-plugin
export default {"buttonContainer":"DeleteButton_buttonContainer__SypxN","deleteButton":"DeleteButton_deleteButton__UpSuY"};